const $_PAYNPLAY = undefined;
export { $_PAYNPLAY };
